/**
 * Join requests on the host's screen (Robert, 2026-10-13): "if another person
 * tries to join or rejoin the group call, the lead in the group call should
 * get a little banner that asks them to accept or decline". The server asks
 * the host (group_join_request) when someone without an active ring wants a
 * seat, and closes the question on every host device (group_join_resolved);
 * vrs-server/ws/group-join-approval.js.
 */
/** The server's answer window when it names none. */
export const GROUP_JOIN_DEFAULT_TIMEOUT_MS = 30000;
/**
 * The list with this request in it (a repeat replaces its row).
 *
 * @param {GroupJoinRequest[]} list - The requests on screen.
 * @param {Object} data - group_join_request.
 * @param {number} now - The current time.
 * @returns {GroupJoinRequest[]}
 */
export function addJoinRequest(list, data, now) {
    const request = {
        callId: data.callId,
        expiresAt: now + (typeof data.timeoutMs === 'number' ? data.timeoutMs : GROUP_JOIN_DEFAULT_TIMEOUT_MS),
        name: typeof data.name === 'string' && data.name.trim() ? data.name.trim() : null,
        rejoin: data.rejoin === true,
        requestId: data.requestId,
        userId: data.userId
    };
    return [...list.filter(entry => entry.requestId !== data.requestId), request];
}
/** The list without this request. */
export function removeJoinRequest(list, requestId) {
    return requestId ? list.filter(entry => entry.requestId !== requestId) : list;
}
/** The list without the requests whose answer window has passed. */
export function pruneJoinRequests(list, now) {
    const kept = list.filter(entry => entry.expiresAt > now);
    return kept.length === list.length ? list : kept;
}
/** The list with this request marked as answered (its buttons wait). */
export function markJoinRequestAnswering(list, requestId) {
    return list.map(entry => (entry.requestId === requestId ? { ...entry, answering: true } : entry));
}
/** What the banner says about one request. */
export function joinRequestText(request) {
    return `${request.name || 'Someone'} wants to ${request.rejoin ? 'rejoin' : 'join'}`;
}
